import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  function handleLogout() {
    logout();
    navigate('/login');
    setOpen(false);
  }

  const isActive = (path) =>
    location.pathname === path ? 'text-yellow-400' : 'text-slate-300 hover:text-white';

  const navLinks = [
    { to: '/', label: 'Lobby' },
    { to: '/profile', label: 'Profil' },
    ...(user?.role === 'admin' ? [{ to: '/admin', label: 'Admin' }] : []),
  ];

  return (
    <nav className="bg-slate-900 border-b border-slate-700 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="h-14 flex items-center justify-between gap-4">
          {/* Logo */}
          <Link to="/" className="text-yellow-400 font-bold text-lg tracking-wide shrink-0">
            🎰 CsabaCasino
          </Link>

          {/* Desktop nav */}
          <div className="hidden sm:flex items-center gap-5">
            {navLinks.map(l => (
              <Link key={l.to} to={l.to} className={`text-sm font-medium transition-colors ${isActive(l.to)}`}>
                {l.label}
              </Link>
            ))}
          </div>

          {/* Right side */}
          <div className="flex items-center gap-2 ml-auto">
            {/* Balance */}
            <div className="bg-slate-800 border border-slate-700 rounded-lg px-2.5 py-1 text-sm">
              <span className="text-yellow-400 font-semibold">{Number(user?.balance ?? 0).toLocaleString('hu')} 💰</span>
            </div>

            {/* Desktop logout */}
            <button onClick={handleLogout} className="hidden sm:block btn-ghost text-sm py-1.5">
              Kilép
            </button>

            {/* Mobile hamburger */}
            <button
              className="sm:hidden p-2 rounded-lg bg-slate-800 text-slate-300 hover:text-white"
              onClick={() => setOpen(o => !o)}
              aria-label="Menü"
            >
              {open ? '✕' : '☰'}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile dropdown */}
      {open && (
        <div className="sm:hidden border-t border-slate-700 bg-slate-900 px-4 py-3 space-y-1">
          {navLinks.map(l => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className={`block py-2 text-sm font-medium ${isActive(l.to)}`}
            >
              {l.label}
            </Link>
          ))}
          <div className="pt-2 border-t border-slate-700">
            <p className="text-slate-500 text-xs mb-2">{user?.username}</p>
            <button onClick={handleLogout} className="btn-danger text-sm w-full">Kijelentkezés</button>
          </div>
        </div>
      )}
    </nav>
  );
}
